import { BTIconEditOutlined } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemRenameProps {
    fileId: number;
    onClick: () => void;
}

const MenuItemRename = ({ fileId, onClick, ...antProps }: IMenuItemRenameProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`rename-menuitem-${fileId}`}
            testid={`rename-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconEditOutlined /> Rename
        </BTMenu.Item>
    );
};

export default MenuItemRename;
